import { ActionIcon, TextInput } from "@mantine/core";
import { IconSearch, IconX } from "@tabler/icons-react";
import classNames from "classnames";
import { useState } from "react";
import { IconButton } from "../../mantine/components/IconButton/IconButton";
import "./SearchBar.scss";

interface SearchBarProps {
  className?: string;
  isLoading?: boolean;
  placeholder?: string;
  btnText?: string;
  btnDisabled?: boolean;
  btnHidden?: boolean;
  inputClassName?: string;
  controlledValue?: string;
  onClear?: () => void;
  onSearch?: (searchValue: string) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

function SearchBar({
  className,
  placeholder = "Suche...",
  btnText = "Suche",
  isLoading = false,
  btnDisabled = false,
  btnHidden = false,
  inputClassName,
  controlledValue,
  onClear,
  onSearch,
  onChange
}: SearchBarProps) {
  const [searchValue, setSearchValue] = useState("");
  const value = controlledValue ?? searchValue;

  function handleKeyDown(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === "Enter") {
      e.preventDefault();
      onSearch?.(value);
    } else if (e.key === "Escape") {
      clearSearch();
    }
  }

  function clearSearch() {
    setSearchValue("");
    onClear?.();
  }

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    onChange?.(e);
    setSearchValue(e.target.value);
  }

  return (
    <div className={classNames("SearchBarWrapper", className)}>
      <div className="search-bar-input">
        <TextInput
          className={classNames("search-bar-input-field", inputClassName)}
          leftSection={<IconSearch size="1.3em" />}
          leftSectionPointerEvents="none"
          placeholder={placeholder}
          role="searchbox"
          type="text"
          value={value}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
        />

        {value?.length > 0 && (
          <ActionIcon
            aria-label="Löschen"
            className="search-bar-clear-btn"
            color="neutral.8"
            size="xs"
            variant="transparent"
            onClick={clearSearch}
          >
            <IconX />
          </ActionIcon>
        )}
      </div>

      {!btnHidden && (
        <IconButton
          disabled={btnDisabled}
          icon={IconSearch}
          loading={isLoading}
          onClick={() => {
            onSearch?.(value);
          }}
        >
          {btnText}
        </IconButton>
      )}
    </div>
  );
}

export { SearchBar, SearchBarProps };
